import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { DjayToetsAvatar } from '../../mascot/DjayToetsAvatar';
import type { AssessmentDomainId } from '../types';
interface AssessmentCompleteScreenProps {
  questionCount: number;
  elapsedMs: number;
  domainId?: AssessmentDomainId;
  onViewReport: () => void;
}
export function AssessmentCompleteScreen({
  questionCount,
  elapsedMs,
  domainId = 'rekenen',
  onViewReport
}: AssessmentCompleteScreenProps) {
  const minutes = Math.floor(elapsedMs / 60000);
  const seconds = Math.floor(elapsedMs % 60000 / 1000);
  const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-800" data-id="element-811">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="w-full max-w-md text-center" data-id="element-812">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.3,
        type: 'spring',
        bounce: 0.5
      }} className="flex justify-center mb-8" data-id="element-813">
          <DjayToetsAvatar domain={domainId} size="lg" animate data-id="element-814" />
        </motion.div>

        <h1 className="text-3xl font-black mb-8 tracking-tight text-slate-900" data-id="element-815">
          Je hebt de toets afgerond!
        </h1>

        <div className="bg-white rounded-3xl p-6 mb-10 border border-slate-200 shadow-sm inline-block text-left min-w-[240px]" data-id="element-816">
          <div className="flex items-center gap-4 mb-4" data-id="element-817">
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0" data-id="element-818">
              <CheckCircle2 className="w-5 h-5 text-slate-400" data-id="element-819" />
            </div>
            <div data-id="element-820">
              <p className="text-slate-500 text-sm font-medium" data-id="element-821">Beantwoord</p>
              <p className="text-xl font-bold text-slate-900" data-id="element-822">
                {questionCount}/{questionCount} vragen
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-823">
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0" data-id="element-824">
              <Clock className="w-5 h-5 text-slate-400" data-id="element-825" />
            </div>
            <div data-id="element-826">
              <p className="text-slate-500 text-sm font-medium" data-id="element-827">Tijd</p>
              <p className="text-xl font-bold text-slate-900" data-id="element-828">
                {timeString} minuten
              </p>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} data-id="element-829">
          <Button onClick={onViewReport} size="xl" className="w-full bg-orange-500 text-white hover:bg-orange-600 shadow-xl rounded-2xl text-fluid-lg font-bold" data-id="element-830">
            <span className="mr-2" data-id="element-831">Bekijk je Rapport</span>
            <ArrowRight className="w-5 h-5" strokeWidth={3} data-id="element-832" />
          </Button>
        </motion.div>
      </motion.div>
    </div>;
}